import './PolicyStyles.css'; // Ensure the correct path to your CSS file
import { exportToWord } from '../utils/exportToWord'; // Import the export function

const CommunicationAndReportingPolicy = ({
  clientName,
  clientAddress,
  effectiveDate,
  companyNumber,
  transportManagerContact,
  reportingContact,
}) => {
  // Handle the export functionality
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Communication_Reporting_Policy.docx");
  };

  return (
    <div className="policy-container">
      <h3 className="policy-title">Accident & Incident Management Policy</h3>
      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> { companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">Purpose</h4>
      <p className="section-content">
        The purpose of this policy is to establish clear and efficient communication and reporting procedures within the company. This policy ensures that all relevant information is communicated accurately and promptly to the appropriate stakeholders.
      </p>

      <h4 className="section-title">Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and third-party service providers involved in the company’s operations. It covers the communication and reporting of operational issues, incidents, and other relevant activities.
      </p>

      <h4 className="section-title">Responsibilities</h4>
      <p className="section-content"><strong>Employees:</strong> Employees are responsible for reporting any operational issues, incidents, or other relevant information in a timely and accurate manner to their supervisor or manager.</p>
      <p className="section-content"><strong>Supervisors/Managers:</strong> Supervisors and managers are responsible for ensuring that information is reported to the correct department or stakeholders. They should also monitor the effectiveness of communication procedures within their teams.</p>
      <p className="section-content"><strong>Transport Managers:</strong> Transport Managers are responsible for coordinating communication between departments and ensuring that relevant information is reported to senior management.</p>

      <h4 className="section-title">Communication Procedures</h4>
      <p className="section-content">
        The following procedures should be followed to ensure effective communication within the organization:
      </p>
      <ul>
        <li><strong>Regular Meetings:</strong> Regular team and departmental meetings should be held to discuss ongoing issues, progress, and areas for improvement.</li>
        <li><strong>Communication Channels:</strong> Established communication channels, such as email, phone, and internal messaging systems, should be used for reporting and communication.</li>
        <li><strong>Escalation Procedure:</strong> If an issue cannot be resolved at the initial level, it should be escalated to the appropriate higher-level authority as per the company’s escalation procedure.</li>
      </ul>

      <h4 className="section-title">Reporting Procedures</h4>
      <p className="section-content">
        Employees and managers must follow the reporting procedures outlined below:
      </p>
      <ul>
        <li><strong>Incident Reporting:</strong> Any incidents (e.g., accidents, injuries, safety breaches) should be reported immediately to the Transport Manager and relevant authorities as needed.</li>
        <li><strong>Operational Reports:</strong> Regular operational reports, including performance, compliance, and maintenance, should be submitted to the management team.</li>
        <li><strong>Feedback Reports:</strong> Employees should provide feedback on processes and procedures to improve communication and reporting within the organization.</li>
      </ul>

      <h4 className="section-title">Emergency Communication</h4>
      <p className="section-content">
        In the event of an emergency, the following communication procedures should be followed:
      </p>
      <ul>
        <li><strong>Immediate Notification:</strong> In the event of an emergency, employees must immediately notify the Transport Manager and other relevant personnel using the designated communication channels.</li>
        <li><strong>Response Teams:</strong> The response team will be notified based on the severity of the emergency, and appropriate action will be taken.</li>
        <li><strong>Post-Incident Reporting:</strong> After the emergency is resolved, a detailed report should be submitted, outlining the events, actions taken, and any follow-up actions required.</li>
      </ul>

      <h4 className="section-title">Emergency Contact Information</h4>
      <p className="section-content">
        The following contact numbers should be used in the event of an emergency:
      </p>
      <ul>
        <li><strong>Transport Manager:</strong> {transportManagerContact || "[Insert Contact Number]"}</li>
        <li><strong>Reporting Service:</strong> {reportingContact || "[Insert Contact Number]"}</li>
        <li><strong>Emergency Services:</strong> [Insert Local Emergency Contact Number]</li>
      </ul>

      <h4 className="section-title">Record Keeping</h4>
      <p className="section-content">
        A record of all communications and reports must be maintained, including the following details:
      </p>
      <ul>
        <li>Details of the report (type of communication, time, and date).</li>
        <li>Names of the individuals involved in the communication or reporting process.</li>
        <li>Actions taken based on the report and any follow-up required.</li>
      </ul>

      <h4 className="section-title">Conclusion</h4>
      <p className="section-content">
        The Communication & Reporting Policy ensures that all operational issues and incidents are reported and communicated effectively across the organization. By following these procedures, we aim to maintain transparency, accountability, and operational efficiency.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Communication & Reporting Policy. I understand my responsibilities for reporting and communication.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      {/* Export to Word Button */}
      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default CommunicationAndReportingPolicy;
